export default "__VITE_ASSET__8e001f58__"